import * as React from "react";
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useContext,
} from "react";
import {
  DataGrid,
  GridApi,
  GridCallbackDetails,
  GridCellEditCommitParams,
  GridCellParams,
  GridColDef,
  GridColumnVisibilityModel,
  GridRenderCellParams,
  GridRowId,
  GridSelectionModel,
  GridValueGetterParams,
  GRID_DEFAULT_LOCALE_TEXT,
  MuiBaseEvent,
  MuiEvent,
  useGridApiContext,
} from "@mui/x-data-grid";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import PageHelper from "../../helper/pageHelper";
import { hasInCache } from "../../helper/cacheHelper";

import "react-confirm-alert/src/react-confirm-alert.css";

import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import IconButton from "@mui/material/IconButton";
import ApprovalIcon from "@mui/icons-material/Approval";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Modal,
  Snackbar,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

import SolicitacaoMaterial from "../../components/classes/SolicitacaoMaterial";
import SolicitacaoMaterialDataset from "../../components/data/MaterialPrimaDataset";
import UnidadeArmazenamentoDataSet from "../../components/data/UnidadeArmazenamentoDataSet";

import CentroDataset from "../../components/data/CentroDataset";
import CentroDistribuicao from "../../components/classes/CentroDistribuicao";

import EraseIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import TopoMateriaPrima from "./topo";
import AutocompleteSku from "../../components/common/AutocompleteSkuMateriaPrima";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import DeleteIcon from "@mui/icons-material/Delete";
/*
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
*/

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";

/* LOCALIZAÇÃO */

import { format } from "date-fns";
import { ca, pt } from "date-fns/locale";
import { ptBR } from "date-fns/locale";
import { confirmAlert } from "react-confirm-alert";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
import AutocompleteCentroMateriaPrima from "../../components/common/AutocompleteCentroMateriaPrima";
import { Send } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import Download from "@mui/icons-material/Download";
import FileUpload from "../../components/common/FileUpload";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";
import moment from "moment";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";
import CSVDetalhesModal from "../../components/common/CSVDetalhesModal/CSVDetalhesModal";
import StepLogsHistoryDetalhe from "../../components/common/StepLogsHistoryModal/StepLogsHistoryDetalhe";

import styles from "./detail.module.css";

import { useTranslation } from "react-i18next";

export default function SolicitacaoMaterialPage() {
  const { t } = useTranslation();

  const steps = [
    t("pages.stuffRequest.text.indicateNeed"),
    t("pages.stuffRequest.text.proposeFulfillment"),
    t("pages.stuffRequest.text.partnerAcceptance"),
    t("pages.stuffRequest.text.approveRequestAndGeneratePurchaseOrder"),
    t("pages.stuffRequest.text.requestedItems"),
  ];

  const user: any = useContext(UserContext);

  const codigoFornecedorSap = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );

  const [solicitacaoMateriais, setSolicitacaoMateriais] = useState<
    SolicitacaoMaterial[]
  >([]);
  const [solicitacaoMateriaisTemp, setSolicitacaoMateriaisTemp] = useState<
    SolicitacaoMaterial[]
  >([]);

  const dataSet: SolicitacaoMaterialDataset = new SolicitacaoMaterialDataset();
  const dataSetCentro: CentroDataset = new CentroDataset();
  const dataSetSku: UnidadeArmazenamentoDataSet =
    new UnidadeArmazenamentoDataSet();
  const [solicitadaEm, setSolicitadaEm] = React.useState<Date | null>(null);
  const [para, setPara] = React.useState<Date | null>(null);
  const [historyId, setHistoryId] = useState(0);
  const [centros, setCentros] = useState<CentroDistribuicao[]>([]);
  const [sku, setSku] = useState<UnidadeArmazenamento[]>([]);
  const [sizePage, setSizePage] = useState(50);
  const [open, setOpen] = React.useState(false);
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);
  const [isOnEdit, setIsOnEdit] = useState<boolean>(false);
  // var data: Data[] = [];
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [rows, setRows] = useState<Data[]>([]);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  const [openSnackBar, setOpenSnackBar] = React.useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{
    wasUpdated: boolean;
    isSuccess: boolean;
    details: string;
  }>({ wasUpdated: false, isSuccess: false, details: "" });
  const [openCSVDetalhesModal, setOpenCSVDetalhesModal] =
    useState<boolean>(false);

  const [loading, setLoading] = React.useState(false);
  const [idsSelecionados, setIdsSelecionados] = useState<GridRowId[]>([]);
  const hasIdSelecionado: boolean = useMemo(
    () => idsSelecionados && idsSelecionados.length > 0,
    [idsSelecionados]
  );

  /* FILTER */
  const [codigoSku, setCodigoSku] = React.useState("");
  const [quantidadeSolicitado, setQuantidadeSoliciatado] = React.useState("");

  useEffect(() => {
    localStorage.setItem("SkuSolicitados", [] as any);
    if (codigoFornecedorSap > 0) {
      dataSetCentro.ListarAtivos().then((centros: CentroDistribuicao[]) => {
        setCentros(centros);

        dataSetSku.ListarAtivos().then((centros: UnidadeArmazenamento[]) => {
          setSku(centros);

          dataSet.ListarAtivos(codigoFornecedorSap).then((result) => {
            const materiasPrimas = result.filter((f) => f.step === step);
            setSolicitacaoMateriais(materiasPrimas);
            setSolicitacaoMateriaisTemp(materiasPrimas);
            Utils.setDocumentTitle(
              t("pages.stuffRequest.text.rawMaterialRequest")
            );
            LoadData(materiasPrimas);
          });
        });
      });
    }
  }, []);

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();
  let _step: number =
    query.get("step")?.valueOf() === undefined
      ? 1
      : Number(query.get("step")?.valueOf());
  let step: number = _step > 0 && _step <= 5 ? _step : 5;

  const handlerDataSolicitadaChange = (params: any, value: string) => {
    const newDate: Date = new Date(value);
    setSolicitacaoMateriais((materiasPrimas) => {
      const materiaPrima = materiasPrimas.find((f) => f.id === params.id);
      if (materiaPrima) {
        materiaPrima.dataPrevisaoNecessidade = newDate;
      }
      LoadData(materiasPrimas);
      return materiasPrimas;
    });
  };

  const handlerDataPropostaChange = (params: any, value: string) => {
    const newDate: Date = new Date(value);
    setSolicitacaoMateriais((materiasPrimas) => {
      const materiaPrima = materiasPrimas.find((f) => f.id === params.id);
      if (materiaPrima) {
        materiaPrima.dataProposta = newDate;
      }
      LoadData(materiasPrimas);
      return materiasPrimas;
    });
  };

  const handlerDataCarregamentoChange = (params: any, value: string) => {
    const newDate: Date = new Date(value);
    setSolicitacaoMateriais((materiasPrimas) => {
      const materiaPrima = materiasPrimas.find((f) => f.id === params.id);
      if (materiaPrima) {
        materiaPrima.dataCarregamento = newDate;
      }
      LoadData(materiasPrimas);
      return materiasPrimas;
    });
  };

  /* Data Grid */
  function MontaColunas() {
    let cols: GridColDef[] = [];

    const columnsStep1: GridColDef[] = [
      {
        field: "deleteico",
        headerName: "",
        width: 50,
        sortable: false,
        renderCell: () => {
          return (
            <Tooltip title={t("common.delete")}>
              <span>
                <IconButton disabled={user.isSuporte}>
                  <EraseIcon />
                </IconButton>
              </span>
            </Tooltip>
          );
        },
      },
      {
        field: "hist",
        headerName: t("common.historic"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Tooltip title={t("common.viewHistoric")}>
            <span>
              <IconButton onClick={() => setHistoryId(params.row.id)}>
                <HistoryToggleOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      },
      {
        field: "id",
        headerName: "#",
        width: 50,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "solicitadoEm",
        headerName: t("common.requestedIn"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
          return dateFormat(params.value);
        },
      },
      {
        field: "dataSolicitada",
        headerName: t("common.for"),
        width: 170,
        editable: false,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return new Date(
              materiaPrimaAtual.dataPrevisaoNecessidade
            ).toISOString() != gridItem.formattedValue.toISOString()
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={`${t("common.for")} *`}
                  value={params.value}
                  onChange={(newValue: any) => {
                    handlerDataSolicitadaChange(params, newValue);
                  }}
                  inputFormat="dd/MM/yyyy"
                  disablePast
                  //allowSameDateSelection
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      size="small"
                      onChange={(value) => {
                        handlerDataSolicitadaChange(
                          params,
                          value.currentTarget.value
                        );
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          );
        },
      },
      {
        field: "siglaSku",
        headerName: t("common.acronym"),
        type: "string",
        width: 190,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (props) => {
          if (props.row.idSkuSolicitado == 0) return "";

          let selectedSku = sku.find(
            (x) => x.idSKU == props.row.idSkuSolicitado
          );

          return <p>{selectedSku?.sigla}</p>;
        },
      },
      {
        field: "skuSolicitado",
        headerName: t("common.requestedSku"),
        width: 450,
        sortable: false,
        editable: true,
        renderEditCell: (params) => {
          return <AutocompleteSku {...params} />;
        },
        renderCell: (gridItem) => {
          return (
            <p>
              {gridItem.row.idSkuSolicitado
                ? montaSkuDescricao(+gridItem.row.idSkuSolicitado)
                : "-"}
            </p>
          );
        },
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuSolicitado !=
              gridItem.row.idSkuSolicitado
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
      },
      {
        field: "idSkuSolicitado",
        headerName: t("common.requestedSkuId"),
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuSolicitado != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "quantidadeSolicitada",
        headerName: t("common.selectedQuantity"),
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        type: "number",
        valueFormatter: (params) => round3(params.value) + " Kg",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.quantidadeSolicitada + " Kg" !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "justificativaSolicitacao",
        headerName: t("common.requestJustify"),
        width: 250,
        editable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.justificativaSolicitacao !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      // { field: 'saveico', headerName: '', width: 50, sortable: false, align: "center",
      //   renderCell: () => { return (<Tooltip title="Salvar"><IconButton> <SaveIcon /></IconButton ></Tooltip>); } }
    ];

    const columnsStep2: GridColDef[] = [
      {
        field: "deleteico",
        headerName: "",
        width: 50,
        sortable: false,
        renderCell: () => {
          return (
            <Tooltip title={t("common.delete")}>
              <span>
                <IconButton disabled={user.isSuporte}>
                  <EraseIcon />
                </IconButton>
              </span>
            </Tooltip>
          );
        },
      },
      {
        field: "hist",
        headerName: t("common.historic"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Tooltip title={t("common.viewHistoric")}>
            <span>
              <IconButton onClick={() => setHistoryId(params.row.id)}>
                <HistoryToggleOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      },
      {
        field: "id",
        headerName: "#",
        width: 50,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
      },
      {
        field: "solicitadoEm",
        headerName: t("common.requestedIn"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) => dateFormat(params.value),
      },
      {
        field: "dataSolicitada",
        headerName: t("common.for"),
        width: 100,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "siglaSku",
        headerName: t("common.acronym"),
        type: "string",
        width: 190,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "skuSolicitadoDescricao",
        headerName: t("common.requestedSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          return <SkuDescricao value={params.value} />;
        },
      },
      {
        field: "quantidadeSolicitada",
        headerName: t("common.selectedQuantity"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        type: "number",
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaSolicitacao",
        headerName: t("common.justify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "dataCarregamento",
        headerName: t("common.loadDate"),
        width: 170,
        editable: false,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            let dataCarregamentoGrid = new Date(
              materiaPrimaAtual.dataCarregamento ?? gridItem.formattedValue
            );
            return dataCarregamentoGrid.toISOString() !=
              gridItem.formattedValue.toISOString()
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={`${t("common.for")} *`}
                  value={params.value}
                  onChange={(newValue: any) => {
                    handlerDataCarregamentoChange(params, newValue);
                  }}
                  inputFormat="dd/MM/yyyy"
                  disablePast
                  // allowSameDateSelection
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      size="small"
                      onChange={(value) => {
                        handlerDataCarregamentoChange(
                          params,
                          value.target.value
                        );
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          );
        },
      },
      {
        field: "dataProposta",
        headerName: t("common.proposalDate"),
        width: 170,
        editable: false,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            let dataPropostaGrid = new Date(
              materiaPrimaAtual.dataProposta ?? gridItem.formattedValue
            );
            return dataPropostaGrid.toISOString() !=
              gridItem.formattedValue.toISOString()
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={`${t("common.for")} *`}
                  value={params.value}
                  onChange={(newValue: any) => {
                    handlerDataPropostaChange(params, newValue);
                  }}
                  inputFormat="dd/MM/yyyy"
                  disablePast
                  // allowSameDateSelection
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      size="small"
                      onChange={(value) => {
                        handlerDataPropostaChange(params, value.target.value);
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          );
        },
      },
      {
        field: "skuProposto",
        headerName: t("common.proposalSku"),
        width: 300,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuProposto != gridItem.row.idSkuProposto
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderEditCell: (params) => {
          return <AutocompleteSku {...params} />;
        },
        renderCell: (gridItem) => {
          return (
            <p>
              {gridItem.row.idSkuProposto
                ? montaSkuDescricao(gridItem.row.idSkuProposto)
                : "-"}
            </p>
          );
        },
      },
      {
        field: "idSkuProposto",
        headerName: t("common.proposalSkuId"),
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuProposto != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "quantidadeProposta",
        headerName: t("common.proposalQuantity"),
        type: "number",
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) => round3(params.value) + " Kg",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.quantidadeProposta + " Kg" !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "justificativaProposta",
        headerName: t("common.proposalJustify"),
        width: 200,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        renderCell: (params) => <SkuDescricao value={params.value} />,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.justificativaProposta !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "centro",
        headerName: t("common.center"),
        width: 150,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.centro != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "centroDescricao",
        headerName: t("common.distributionCenter"),
        width: 300,
        editable: true,
        sortable: false,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.centro != gridItem.row.centro
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderEditCell: (params) => {
          return <AutocompleteCentroMateriaPrima {...params} />;
        },
        renderCell: (gridItem) => {
          return <p>{montaCentroDescricao(gridItem.row.centro)}</p>;
        },
      },
      {
        field: "deposito",
        headerName: t("common.warehouse"),
        width: 150,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.deposito != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },

      // { field: 'saveico', headerName: '', width: 50, sortable: false, align: "center",
      //   renderCell: () => { return (<Tooltip title="Salvar"><IconButton> <SaveIcon /></IconButton ></Tooltip>); } }
    ];

    const columnsStep3: GridColDef[] = [
      {
        field: "id",
        headerName: "#",
        width: 50,
        align: "center",
        headerAlign: "center",
        editable: false,
      },
      {
        field: "hist",
        headerName: t("common.historic"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Tooltip title={t("common.viewHistoric")}>
            <span>
              <IconButton onClick={() => setHistoryId(params.row.id)}>
                <HistoryToggleOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      },
      {
        field: "solicitadoEm",
        headerName: t("common.requestedIn"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
          return dateFormat(params.value);
        },
      },
      {
        field: "dataSolicitada",
        headerName: t("common.for"),
        width: 100,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "siglaSku",
        headerName: t("common.acronym"),
        type: "string",
        width: 190,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "skuSolicitadoDescricao",
        headerName: t("common.requestedSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "quantidadeSolicitada",
        headerName: t("common.selectedQuantity"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        type: "number",
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaSolicitacao",
        headerName: t("common.justify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "dataCarregamento",
        headerName: t("common.loadDate"),
        width: 140,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "dataProposta",
        headerName: t("common.proposalDate"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "skuPropostoDescricao",
        headerName: t("common.proposalSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "quantidadeProposta",
        headerName: t("common.proposalQuantity"),
        type: "number",
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaProposta",
        headerName: t("common.proposalJustify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "centroDescricao",
        headerName: t("common.center"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "deposito",
        headerName: t("common.warehouse"),
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
    ];

    const columnsStep4: GridColDef[] = [
      {
        field: "id",
        headerName: "#",
        width: 50,
        align: "center",
        headerAlign: "center",
        editable: false,
      },
      {
        field: "hist",
        headerName: t("common.historic"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Tooltip title={t("common.viewHistoric")}>
            <span>
              <IconButton onClick={() => setHistoryId(params.row.id)}>
                <HistoryToggleOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      },
      {
        field: "solicitadoEm",
        headerName: t("common.requestedIn"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
          return dateFormat(params.value);
        },
      },
      {
        field: "dataSolicitada",
        headerName: t("common.for"),
        width: 100,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "siglaSku",
        headerName: t("common.acronym"),
        type: "string",
        width: 190,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "skuSolicitadoDescricao",
        headerName: t("common.requestedSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "quantidadeSolicitada",
        headerName: t("common.selectedQuantity"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        type: "number",
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaSolicitacao",
        headerName: t("common.justify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "dataCarregamento",
        headerName: t("common.loadDate"),
        width: 170,
        editable: false,
        align: "center",
        headerAlign: "center",
        cellClassName: "MuiDataGrid-cell--editable",
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={`${t("common.for")} *`}
                  value={params.value}
                  onChange={(newValue: any) => {
                    handlerDataCarregamentoChange(params, newValue);
                  }}
                  inputFormat="dd/MM/yyyy"
                  disablePast
                  // allowSameDateSelection
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      size="small"
                      onChange={(value) => {
                        handlerDataCarregamentoChange(
                          params,
                          value.target.value
                        );
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          );
        },
      },
      {
        field: "dataProposta",
        headerName: t("common.proposalDate"),
        width: 170,
        editable: false,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            let dataPropostaGrid = new Date(
              materiaPrimaAtual.dataProposta ?? gridItem.formattedValue
            );
            return dataPropostaGrid.toISOString() !=
              gridItem.formattedValue.toISOString()
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={`${t("common.for")} *`}
                  value={params.value}
                  onChange={(newValue: any) => {
                    handlerDataPropostaChange(params, newValue);
                  }}
                  inputFormat="dd/MM/yyyy"
                  disablePast
                  // allowSameDateSelection
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      size="small"
                      onChange={(value) => {
                        handlerDataPropostaChange(params, value.target.value);
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          );
        },
      },
      {
        field: "skuProposto",
        headerName: t("common.proposalSku"),
        width: 300,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuProposto != gridItem.row.idSkuProposto
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderEditCell: (params) => {
          return <AutocompleteSku {...params} />;
        },
        renderCell: (gridItem) => {
          return (
            <p>
              {gridItem.row.idSkuProposto
                ? montaSkuDescricao(gridItem.row.idSkuProposto)
                : "-"}
            </p>
          );
        },
      },
      {
        field: "idSkuProposto",
        headerName: t("common.proposalSkuId"),
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.idSkuProposto != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "quantidadeProposta",
        headerName: t("common.proposalQuantity"),
        type: "number",
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) => round3(params.value) + " Kg",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.quantidadeProposta + " Kg" !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "justificativaProposta",
        headerName: t("common.proposalJustify"),
        width: 200,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        renderCell: (params) => <SkuDescricao value={params.value} />,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.justificativaProposta !=
              gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "centro",
        headerName: t("common.center"),
        width: 150,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.centro != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "centroDescricao",
        headerName: t("common.center"),
        width: 300,
        editable: true,
        sortable: false,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.centro != gridItem.row.centro
              ? "celulaAlterada"
              : "MuiDataGrid-cell--editable";
          }
          return "MuiDataGrid-cell--editable";
        },
        renderEditCell: (params) => {
          return <AutocompleteCentroMateriaPrima {...params} />;
        },
        renderCell: (gridItem) => {
          return <p>{montaCentroDescricao(gridItem.row.centro)}</p>;
        },
      },
      {
        field: "deposito",
        headerName: t("common.warehouse"),
        width: 150,
        editable: true,
        align: "center",
        headerAlign: "center",
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriaisTemp.find(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          );
          if (materiaPrimaAtual) {
            return materiaPrimaAtual.deposito != gridItem.formattedValue
              ? "celulaAlterada"
              : "";
          }
          return "";
        },
      },
      {
        field: "contrato",
        headerName: t("common.contract"),
        width: 120,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriais.filter(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          )[0];

          let foiAlterado =
            materiaPrimaAtual.contrato != gridItem.formattedValue;
          return foiAlterado ? "celulaAlterada" : "";
        },
      },
      {
        field: "observacao",
        headerName: t("common.observationRule"),
        width: 200,
        editable: true,
        align: "center",
        headerAlign: "center",
        sortable: true,
        cellClassName: (gridItem: any) => {
          let materiaPrimaAtual = solicitacaoMateriais.filter(
            (solicitacaoMaterial) => solicitacaoMaterial.id == gridItem.id
          )[0];

          let foiAlterado =
            materiaPrimaAtual.observacao != gridItem.formattedValue;
          return foiAlterado ? "celulaAlterada" : "";
        },
      },
    ];

    const columnsStep5: GridColDef[] = [
      {
        field: "id",
        headerName: "#",
        width: 50,
        align: "center",
        headerAlign: "center",
        editable: false,
      },
      {
        field: "hist",
        headerName: t("common.historic"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Tooltip title={t("common.viewHistoric")}>
            <span>
              <IconButton onClick={() => setHistoryId(params.row.id)}>
                <HistoryToggleOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      },
      {
        field: "solicitadoEm",
        headerName: t("common.requestedIn"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (params) => {
          return dateFormat(params.value);
        },
      },
      {
        field: "dataSolicitada",
        headerName: t("common.for"),
        width: 100,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "siglaSku",
        headerName: t("common.acronym"),
        type: "string",
        width: 190,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "skuSolicitadoDescricao",
        headerName: t("common.requestedSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "quantidadeSolicitada",
        headerName: t("common.selectedQuantity"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        type: "number",
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaSolicitacao",
        headerName: t("common.justify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "dataCarregamento",
        headerName: t("common.loadDate"),
        width: 140,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "dataProposta",
        headerName: t("common.proposalDate"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) =>
          params.value ? dateFormat(params.value) : "",
      },
      {
        field: "skuPropostoDescricao",
        headerName: t("common.proposalSku"),
        width: 300,
        editable: false,
        sortable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "quantidadeProposta",
        headerName: t("common.proposalQuantity"),
        type: "number",
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        valueFormatter: (params) => round3(params.value) + " Kg",
      },
      {
        field: "justificativaProposta",
        headerName: t("common.proposalJustify"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
        renderCell: (params) => <SkuDescricao value={params.value} />,
      },
      {
        field: "centroDescricao",
        headerName: t("common.center"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "deposito",
        headerName: t("common.warehouse"),
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "contrato",
        headerName: t("common.contract"),
        width: 120,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
      },
      {
        field: "observacao",
        headerName: t("common.observationRule"),
        width: 200,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: true,
      },
    ];

    if (step === 1) {
      cols = columnsStep1;
    } else if (step === 2) {
      cols = columnsStep2;
    } else if (step === 3) {
      cols = columnsStep3;
    } else if (step === 4) {
      cols = columnsStep4;
    } else if (step === 5) {
      cols = columnsStep5;
    }
    setColumns(cols);
    setColumnVisibilityModel({
      idSkuSolicitado: false,
      idSkuProposto: false,
      centro: false,
    });
  }

  interface Data {
    id: Number;
    solicitadoEm: Date;
    dataSolicitada: Date;
    idSkuSolicitado: Number;
    skuSolicitadoDescricao?: string;
    quantidadeSolicitada: Number;
    justificativaSolicitacao: String;
    dataProposta?: Date;
    idSkuProposto?: Number;
    skuPropostoDescricao?: string;
    quantidadeProposta?: Number;
    justificativaProposta?: String;
    aprovadoEm?: Date;
    idskusolinline?: Number;
    idskupropinline?: Number;
    contrato?: String;
    centro?: String;
    deposito?: String;
    centroDescricao?: String;
    dataCarregamento?: Date;
    observacao?: String;
    siglaSku?: String;
  }

  const round3 = (value: number) => {
    return value ? stripZeros(value.toFixed(3)) : 0;
  };

  const stripZeros = (str: string) => {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  };

  const dateFormat = (date: Date): string => {
    return date.toLocaleDateString("pt-BR");
  };

  const montaCentroDescricao = (centro: String) => {
    const centroFound: CentroDistribuicao | undefined = centros.find(
      (f) => f.centro === centro
    );
    return centroFound ? `${centroFound.centro} - ${centroFound.nome}` : "";
  };

  const montaSkuDescricao = (idSku: number) => {
    const skuFound: UnidadeArmazenamento | undefined = sku.find(
      (x) => x.idSKU == idSku
    );
    return skuFound ? `${idSku} - ${skuFound.descricao}` : "";
  };

  const createData = (
    id: Number,
    solicitadoEm: Date,
    dataSolicitada: Date,
    idSkuSolicitado: Number,
    quantidadeSolicitada: Number,
    justificativaSolicitacao: String,
    dataProposta: Date,
    idSkuProposto: Number,
    quantidadeProposta: Number,
    justificativaProposta: String,
    contrato: String,
    centro: String,
    deposito: String,
    dataCarregamento: Date,
    observacao: String,
    aprovadoEm?: Date,
    idskusolinline?: Number,
    idskupropinline?: Number,
    skuSolicitadoDescricao?: string,
    skuPropostoDescricao?: string,
    centroDescricao?: string,
    siglaSku?: string
  ): Data => {
    return {
      id,
      solicitadoEm,
      dataSolicitada,
      idSkuSolicitado,
      quantidadeSolicitada,
      justificativaSolicitacao,
      dataProposta,
      idSkuProposto,
      quantidadeProposta,
      justificativaProposta,
      contrato,
      aprovadoEm,
      idskusolinline,
      idskupropinline,
      skuSolicitadoDescricao: skuSolicitadoDescricao ?? "",
      skuPropostoDescricao: skuPropostoDescricao ?? "",
      centro,
      deposito,
      centroDescricao: centroDescricao ?? "",
      dataCarregamento,
      observacao,
      siglaSku,
    };
  };

  const addLinha = () => {
    adicionarMaterial(0, new Date(), new Date(), 0, 0, "", false).then(() =>
      PageHelper.refreshPage()
    );
  };

  const onCellEditCommit = (
    params: GridCellEditCommitParams,
    _event: MuiEvent<MuiBaseEvent>
  ) => {
    const rowIndex = solicitacaoMateriais.findIndex(
      (row) => row.id === params.id
    );
    if (rowIndex >= 0) {
      const row = solicitacaoMateriais[rowIndex] as any;
      if (params.field in row && row[params.field] !== params.value) {
        const tempList = [...solicitacaoMateriais] as any;
        tempList[rowIndex][params.field] = params.value;
        setSolicitacaoMateriais(tempList);
      }
    }
    setIsOnEdit(false);
  };

  useEffect(() => {
    // if (solicitacaoMateriais.length > 0) {
    MontaColunas();
    LoadData(solicitacaoMateriais);
    // }
  }, [solicitacaoMateriais]);

  useEffect(() => {
    setOpenDownload(false);
    if (csvFoiEnviado.wasUpdated) {
      setOpenSnackBar(true);
      if (csvFoiEnviado.isSuccess) {
        setLoading(true);
        dataSet.ListarAtivos(codigoFornecedorSap).then((result) => {
          const materiasPrimas = result.filter((f) => f.step === step);
          setSolicitacaoMateriais(materiasPrimas);
          LoadData(materiasPrimas);
          setLoading(false);
        });
      }
    }
  }, [csvFoiEnviado]);

  const LoadData = (registros: SolicitacaoMaterial[]) => {
    setRows(
      registros?.map((item: SolicitacaoMaterial) => {
        return createData(
          item.id,
          new Date(),
          item.dataPrevisaoNecessidade
            ? new Date(item.dataPrevisaoNecessidade)
            : new Date(),
          item.idSkuSolicitado,
          item.quantidadeSolicitada,
          item.justificativaSolicitacao,
          item.dataProposta ? new Date(item.dataProposta) : new Date(),
          item.idSkuProposto,
          item.quantidadeProposta,
          item.justificativaProposta,
          item.contrato,
          item.centro,
          item.deposito,
          item.dataCarregamento ? new Date(item.dataCarregamento) : new Date(),
          item.observacao,
          item.stepForward,
          item.idSkuSolicitado,
          item.idSkuProposto,
          item.skuSolicitadoDescricao,
          item.skuPropostoDescricao,
          item.centroDescricao,
          item.siglaSku
        );
      })
    );
    // }
  };

  const [activeStep, setActiveStep] = React.useState(step - 1);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return step === 500;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    let _step = activeStep + 2;
    _step = _step > 5 || _step < 0 ? (_step = 1) : _step;
    window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    let _step = activeStep;
    _step = _step > 5 || _step < 0 ? (_step = 1) : _step;
    window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick: () => {
            setOpen(false);
            if (refresh) {
              PageHelper.refreshPage();
            }
          },
        },
      ],
    });
  };

  const salvarLista = () => {
    setLoading(true);
    const materiaisSelecionados: SolicitacaoMaterial[] =
      solicitacaoMateriais.filter((f) =>
        idsSelecionados.includes(f.id as number)
      );
    if (materiaisSelecionados && materiaisSelecionados.length > 0) {
      let erro = null;
      for (const material of materiaisSelecionados) {
        const data: Data | undefined = rows.find((f) => f.id === material.id);
        material.step = step;
        if (!material.observacao) {
          material.observacao = "";
        }
        if (data) {
          erro = validarDatas(data);
          if (erro) {
            break;
          }
          material.aprovadoBRF = false;
          material.aprovadoParceiro = false;
          if (step === 1) {
            material.dataPrevisaoNecessidade = data.dataSolicitada;
            material.idSkuSolicitado = data.idSkuSolicitado;
            material.quantidadeSolicitada = data.quantidadeSolicitada;
            material.justificativaSolicitacao = data.justificativaSolicitacao;
          } else if (step === 2) {
            if (data.dataProposta) {
              material.dataProposta = data.dataProposta;
            }
            if (data.idSkuProposto) {
              material.idSkuProposto = data.idSkuProposto;
            }
            if (data.quantidadeProposta) {
              material.quantidadeProposta = data.quantidadeProposta;
            }
            if (data.justificativaProposta) {
              material.justificativaProposta = data.justificativaProposta;
            }
            if (data.centro) {
              material.centro = data.centro;
            }
            if (data.deposito) {
              material.deposito = data.deposito;
            }
            if (data.dataCarregamento) {
              material.dataCarregamento = data.dataCarregamento;
            }
            if (data.contrato) {
              material.contrato = data.contrato;
            }
            if (data.observacao) {
              material.observacao = data.observacao;
            }
          }
        }
      }

      if (erro) {
        setLoading(false);
        Mensagem(t("common.error"), erro, false);
      } else {
        dataSet
          .AtualizarColecao(materiaisSelecionados)
          .then((result) => {
            if (result) {
              Mensagem(
                t("common.warning"),
                t("pages.stuffRequest.text.itemsSavedSuccessfully"),
                true
              );
            } else {
              Mensagem(
                t("common.error"),
                t("pages.stuffRequest.text.errorTryingToSave"),
                true
              );
            }
          })
          .catch((erro) => {
            console.log(erro);
            Mensagem(
              t("common.error"),
              t("pages.stuffRequest.text.errorTryingToSave"),
              true
            );
          });
      }
    }
  };

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      const material: SolicitacaoMaterial | undefined =
        solicitacaoMateriais.find((f) => f.id === Number(cellValues.row.id));
      if (material) {
        if (!material.observacao) {
          material.observacao = "";
        }
        if (cellValues.field === "deleteico") {
          dataSet
            .Apagar(material)
            .then((result) => {
              if (result) {
                Mensagem(
                  t("common.warning"),
                  t("pages.stuffRequest.text.itemDeletedSuccessfully"),
                  true
                );
              } else {
                Mensagem(
                  t("common.error"),
                  t("pages.stuffRequest.text.errorTryingToDelete"),
                  true
                );
              }
            })
            .catch((erro) => {
              console.log(erro);
              Mensagem(
                t("common.error"),
                t("pages.stuffRequest.text.errorTryingToDelete"),
                true
              );
            });
        } else if (cellValues.field === "saveico") {
          material.step = step;
          if (step === 1) {
            material.dataPrevisaoNecessidade = cellValues.row.dataSolicitada;
            material.idSkuSolicitado = cellValues.row.idSkuSolicitado;
            material.quantidadeSolicitada = cellValues.row.quantidadeSolicitada;
            material.justificativaSolicitacao =
              cellValues.row.justificativaSolicitacao;
          } else if (step === 2) {
            material.dataProposta = cellValues.row.dataProposta;
            material.idSkuProposto = cellValues.row.idSkuProposto;
            material.quantidadeProposta = cellValues.row.quantidadeProposta;
            material.justificativaProposta =
              cellValues.row.justificativaProposta;
            material.centro = cellValues.row.centro;
            material.deposito = cellValues.row.deposito;
          }
          dataSet
            .Atualizar(material)
            .then((result) => {
              if (result) {
                Mensagem(
                  t("common.warning"),
                  t("pages.stuffRequest.text.itemSaveSuccessfully"),
                  true
                );
              } else {
                Mensagem(
                  t("common.error"),
                  t("pages.stuffRequest.text.errorTryingToSave"),
                  true
                );
              }
            })
            .catch((erro) => {
              console.log(erro);
              Mensagem(
                t("common.error"),
                t("pages.stuffRequest.text.errorTryingToSave"),
                true
              );
            });
        } else {
          adicionarMaterial(
            cellValues.row.id,
            cellValues.row.solicitadoEm,
            cellValues.row.dataSolicitada,
            cellValues.row.idSkuSolicitado,
            cellValues.row.quantidadeSolicitada,
            cellValues.row.justificativaSolicitacao
          );
        }
      }
    }
  };

  const reprovarMateriais = () => {
    setLoading(true);
    const materiaisSelecionados: SolicitacaoMaterial[] =
      solicitacaoMateriais.filter((f) =>
        idsSelecionados.includes(f.id as number)
      );
    if (materiaisSelecionados && materiaisSelecionados.length > 0) {
      materiaisSelecionados.forEach((solicitacaoMaterial) => {
        const data: Data | undefined = rows.find(
          (f) => f.id === solicitacaoMaterial.id
        );
        if (data) {
          if (!solicitacaoMaterial.observacao) {
            solicitacaoMaterial.observacao = "";
          }
          solicitacaoMaterial.step = step;
          solicitacaoMaterial.aprovadoParceiro = false;
          solicitacaoMaterial.aprovadoBRF = false;
          dataSet
            .Atualizar(solicitacaoMaterial)
            .then((result) => {
              setLoading(false);
              if (result) {
                Mensagem(
                  t("common.warning"),
                  t("pages.stuffRequest.text.itemRejectedSuccessfully"),
                  true
                );
              } else {
                Mensagem(
                  t("common.error"),
                  t("pages.stuffRequest.text.errorTryingFailed"),
                  true
                );
              }
            })
            .catch((erro) => {
              setLoading(false);
              console.log(erro);
              Mensagem(
                t("common.error"),
                t("pages.stuffRequest.text.errorTryingFailed"),
                true
              );
            });
        }
      });
    }
  };

  const handleConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            await setOpen(false);
            aprovarMateriais();
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const excluirMateriais = async () => {
    try {
      await dataSet.ApagarLote(idsSelecionados.map((x) => +x));

      let msg =
        idsSelecionados.length > 1
          ? t("pages.stuffRequest.text.itemsDeletedSuccessfully")
          : t("pages.stuffRequest.text.itemDeletedSuccessfully");

      Mensagem(t("common.exclusion"), msg, true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            await setOpen(false);
            excluirMateriais();
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const aprovarMateriais = () => {
    setLoading(true);
    const materiaisSelecionados: SolicitacaoMaterial[] =
      solicitacaoMateriais.filter((f) =>
        idsSelecionados.includes(f.id as number)
      );
    if (materiaisSelecionados && materiaisSelecionados.length > 0) {
      const materiaPrimaParaIntegrar: SolicitacaoMaterial[] = [];

      let erro = null;
      for (const solicitacaoMaterial of materiaisSelecionados) {
        const data: Data | undefined = rows.find(
          (f) => f.id === solicitacaoMaterial.id
        );
        if (data) {
          erro = validarDatas(data);
          if (erro) {
            break;
          }
          if (!solicitacaoMaterial.observacao) {
            solicitacaoMaterial.observacao = "";
          }
          solicitacaoMaterial.step = step;
          if (step === 1) {
            solicitacaoMaterial.aprovadoParceiro = true;
            if (data.idSkuSolicitado) {
              solicitacaoMaterial.idSkuSolicitado = data.idSkuSolicitado;
            }
            if (data.quantidadeSolicitada) {
              solicitacaoMaterial.quantidadeSolicitada =
                data.quantidadeSolicitada;
            }
            if (data.dataSolicitada) {
              solicitacaoMaterial.dataPrevisaoNecessidade = data.dataSolicitada;
            }
            if (data.justificativaSolicitacao) {
              solicitacaoMaterial.justificativaSolicitacao =
                data.justificativaSolicitacao;
            }
          } else if (step === 2) {
            solicitacaoMaterial.aprovadoBRF = true;
            if (data.dataProposta) {
              solicitacaoMaterial.dataProposta = data.dataProposta;
            }
            if (data.idSkuProposto) {
              solicitacaoMaterial.idSkuProposto = data.idSkuProposto;
            }
            if (data.quantidadeProposta) {
              solicitacaoMaterial.quantidadeProposta = data.quantidadeProposta;
            }
            if (data.justificativaProposta) {
              solicitacaoMaterial.justificativaProposta =
                data.justificativaProposta;
            }
            if (data.centro) {
              solicitacaoMaterial.centro = data.centro;
            }
            if (data.deposito) {
              solicitacaoMaterial.deposito = data.deposito;
            }
            if (data.dataCarregamento) {
              solicitacaoMaterial.dataCarregamento = data.dataCarregamento;
            }
          } else if (step === 3) {
            solicitacaoMaterial.aprovadoParceiro = true;
            solicitacaoMaterial.aprovadoBRF = true;
          } else if (step === 4) {
            solicitacaoMaterial.aprovadoParceiro = true;
            solicitacaoMaterial.aprovadoBRF = true;
            if (data.contrato) {
              solicitacaoMaterial.contrato = data.contrato;
            }
            if (data.observacao) {
              solicitacaoMaterial.observacao = data.observacao;
            }
          }
          materiaPrimaParaIntegrar.push(solicitacaoMaterial);
        }
      }

      if (erro) {
        setLoading(false);
        Mensagem(t("common.error"), erro, false);
      } else {
        dataSet
          .AtualizarColecao(materiaPrimaParaIntegrar)
          .then((result) => {
            setLoading(false);
            if (result) {
              Mensagem(
                t("common.warning"),
                t("pages.stuffRequest.text.itemApprovedSuccessfully"),
                true
              );
            } else {
              Mensagem(
                t("common.error"),
                t("pages.stuffRequest.text.errorTryingToApprove"),
                true
              );
            }
          })
          .catch((erro) => {
            setLoading(false);
            console.log(erro);
            Mensagem(
              t("common.error"),
              t("pages.stuffRequest.text.errorTryingToApprove"),
              true
            );
          });
      }
    }
  };

  function validarDatas(data: Data): string | null {
    const tempSolicitadoEm = zerarHoraMinutoSegundo(data.solicitadoEm);

    if (data.dataProposta && data.dataProposta < tempSolicitadoEm) {
      return t("pages.stuffRequest.text.proposedDateEarlier");
    }
    if (data.dataCarregamento && data.dataCarregamento < tempSolicitadoEm) {
      return t("pages.stuffRequest.text.uploadDateEarlier");
    }
    return null;
  }

  function zerarHoraMinutoSegundo(date: Date) {
    const newDate = clonarDate(date);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  }

  function clonarDate(date: Date) {
    return new Date(date.getTime());
  }

  async function adicionarMaterial(
    id: Number,
    criadoEm: Date,
    dataPrevisaoNecessidade: Date,
    idSkuSolicitado: Number,
    quantidadeSolicitada: Number,
    justificativaSolicitacao: String,
    showMessage: boolean = true
  ) {
    var materialToAdd: SolicitacaoMaterial = new SolicitacaoMaterial();
    materialToAdd.id = id;
    materialToAdd.codigoFornecedorSap = codigoFornecedorSap;
    materialToAdd.criadoEm = criadoEm;
    materialToAdd.dataPrevisaoNecessidade = dataPrevisaoNecessidade;
    materialToAdd.idSkuSolicitado = idSkuSolicitado;
    materialToAdd.quantidadeSolicitada = quantidadeSolicitada;
    materialToAdd.justificativaSolicitacao = justificativaSolicitacao;
    materialToAdd.step = 1;

    return dataSet
      .Adicionar(materialToAdd)
      .then((result) => {
        if (showMessage) {
          if (result) {
            Mensagem(
              t("common.warning"),
              t("pages.stuffRequest.text.itemAddedSucessfully"),
              true
            );
          } else {
            Mensagem(
              t("common.error"),
              t("pages.stuffRequest.text.errorTryingToInclude"),
              true
            );
          }
        }
      })
      .catch((erro) => {
        console.log(erro);
        if (showMessage) {
          Mensagem(
            t("common.error"),
            t("pages.stuffRequest.text.errorTryingToInclude"),
            true
          );
        }
      });
  }

  function handleSelectionChange(ids: GridSelectionModel) {
    setIdsSelecionados(ids);
  }

  interface downloadStep1 {
    idSku: string;
    dataAnoMesDia: string;
    quantidade: string;
    justificativa: string;
  }

  interface downloadStep2 {
    idSkuSolicitado: string;
    dataSolicitadaAnoMesDia: string;
    idSkuProposto: string;
    dataCarregamentoAnoMesDia: string;
    dataPropostaAnoMesDia: string;
    quantidade: string;
    justificativa: string;
    centro: string;
    deposito: string;
  }

  function createDownloadStep1(
    idSku: string,
    data: Date,
    quantidade: string,
    justificativa: string
  ): downloadStep1 {
    const dataTemp = data ? new Date(data) : new Date();

    const dataAnoMesDia: string =
      dataTemp.getFullYear() +
      "-" +
      ("0" + (dataTemp.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dataTemp.getDate()).slice(-2);
    return {
      idSku,
      dataAnoMesDia,
      quantidade,
      justificativa,
    };
  }

  function createDownloadStep2(
    idSkuSolicitado: string,
    dataSolicitada: Date,
    idSkuProposto: string,
    dataCarregamento: Date,
    dataProposta: Date,
    quantidade: string,
    justificativa: string,
    centro: string,
    deposito: string
  ): downloadStep2 {
    const dataSolicitadaTemp = dataSolicitada
      ? new Date(dataSolicitada)
      : new Date();
    const dataCarregamentoTemp = dataCarregamento
      ? new Date(dataCarregamento)
      : new Date();
    const dataPropostaTemp = dataProposta ? new Date(dataProposta) : new Date();

    const dataSolicitadaAnoMesDia: string =
      dataSolicitadaTemp.getFullYear() +
      "-" +
      ("0" + (dataSolicitadaTemp.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dataSolicitadaTemp.getDate()).slice(-2);
    const dataCarregamentoAnoMesDia: string =
      dataCarregamentoTemp.getFullYear() +
      "-" +
      ("0" + (dataCarregamentoTemp.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dataCarregamentoTemp.getDate()).slice(-2);
    const dataPropostaAnoMesDia: string =
      dataPropostaTemp.getFullYear() +
      "-" +
      ("0" + (dataPropostaTemp.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + dataPropostaTemp.getDate()).slice(-2);

    return {
      idSkuSolicitado,
      dataSolicitadaAnoMesDia,
      idSkuProposto,
      dataCarregamentoAnoMesDia,
      dataPropostaAnoMesDia,
      quantidade,
      justificativa,
      centro,
      deposito,
    };
  }

  const handleClickOpenDownload = () => {
    setOpenDownload(true);
  };

  const handleCloseDownload = () => {
    setOpenDownload(false);
  };

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  function handleClickOpenCSVDetalhesModal() {
    setOpenCSVDetalhesModal(true);
  }

  function handleCloseCSVDetalhesModal() {
    setOpenCSVDetalhesModal(false);
  }

  const isMateriaisListEmpty: boolean = useMemo((): boolean => {
    return !solicitacaoMateriais || solicitacaoMateriais.length === 0;
  }, [solicitacaoMateriais]);

  function FileUploadPage() {
    return (
      <div>
        <FileUpload
          {...{
            endpoint:
              "Solicitacao/MateriaPrima/ProcessarPlanilha/Parceiro/" +
              codigoFornecedorSap +
              "/Passo/" +
              step,
            setCsvFoiEnviado: setCsvFoiEnviado,
          }}
        />
      </div>
    );
  }

  const [openFilter, setOpenFilter] = React.useState(false);
  const [filtra, setFiltra] = React.useState(false);

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleClickFilter = () => {
    if (filtra) {
      LoadData(solicitacaoMateriais);
    } else {
      handleClickOpenFilter();
    }
    setFiltra(!filtra);
  };

  const handleFilter = async () => {
    const requestData = {
      solicitadaEm:
        solicitadaEm != null ? moment(solicitadaEm).format("YYYY-MM-DD") : null,
      para: para != null ? moment(para).format("YYYY-MM-DD") : null,
      codigoSku,
      quantidadeSolicitado,
    };

    const filtered: SolicitacaoMaterial[] = await dataSet.RecuperarPorFiltros(
      requestData,
      codigoFornecedorSap
    );

    if (filtered.length > 0) {
      LoadData(filtered);
    }

    setOpenFilter(false);
  };

  const getDownloadColumns = () => {
    return columns.filter(
      (x) =>
        x.field != "siglaSku" &&
        x.field != "deleteico" &&
        x.field != "centroDescricao" &&
        x.field != "skuProposto" &&
        x.field != "hist" &&
        x.field != "skuSolicitado"
    );
  };

  return (
    <div className={`container ${styles.container}`}>
      <div className="containerTitle">
        <TopoMateriaPrima />
      </div>
      <div className="containerToolbar">
        {step === 1 || step === 2 || step == 4 ? (
          <Tooltip
            title={t("pages.stuffRequest.text.saveChangesToSelectedData")}
          >
            <span>
              <IconButton
                onClick={salvarLista}
                disabled={
                  !hasIdSelecionado || loading || user.isSuporte || isOnEdit
                }
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
        {filtra === false ? (
          <Tooltip title={t("pages.stuffRequest.text.enablesFiltering")}>
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={t("pages.stuffRequest.text.disableFilters")}>
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!filtra || loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        <React.Fragment>
          {step === 1 ? (
            <Tooltip title={t("pages.stuffRequest.text.addLine")}>
              <span>
                <IconButton
                  onClick={addLinha}
                  disabled={loading || user.isSuporte || isOnEdit}
                >
                  <AddCircleIcon />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
        {step === 1 || step === 2 ? (
          <Tooltip title={t("pages.stuffRequest.text.uploadCsv")}>
            <span>
              <IconButton
                onClick={handleClickOpenDownload}
                disabled={loading || user.isSuporte || isOnEdit}
              >
                <FileUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
        {step === 1 ? (
          // <CSVLink filename="materiaPrimaSolicitacao.csv" data={solicitacaoMateriais.map((item) => {
          //   return createDownloadStep1(item.idSkuSolicitado.toString(), item.dataPrevisaoNecessidade,
          //     stripZeros(String(item.quantidadeSolicitada)), item.justificativaSolicitacao?.toString());
          // })}
          //   enclosingCharacter={``}
          //   separator={";"}
          //   hidden={isMateriaisListEmpty}>
          <Tooltip title={t("pages.stuffRequest.text.downloadCsv")}>
            <span>
              <IconButton
                onClick={handleClickOpenDownloadCSV}
                disabled={
                  loading || user.isSuporte || isMateriaisListEmpty || isOnEdit
                }
              >
                <Download />
              </IconButton>
            </span>
          </Tooltip>
        ) : // </CSVLink>
        null}
        {step === 2 ? (
          // <CSVLink filename="materiaPrimaProposta.csv" data={solicitacaoMateriais.map((item) => {
          //   return createDownloadStep2(item.idSkuSolicitado.toString(), item.dataPrevisaoNecessidade,
          //     item.idSkuProposto.toString(), item.dataCarregamento, item.dataProposta,
          //     stripZeros(String(item.quantidadeProposta)), item.justificativaProposta?.toString(),
          //     item.centro?.toString(), item.deposito?.toString());
          // })}
          //   enclosingCharacter={``}
          //   separator={";"}
          //   hidden={isMateriaisListEmpty}>
          <Tooltip title={t("pages.stuffRequest.text.downloadCsv")}>
            <span>
              <IconButton
                onClick={handleClickOpenDownloadCSV}
                disabled={
                  loading || user.isSuporte || isMateriaisListEmpty || isOnEdit
                }
              >
                <Download />
              </IconButton>
            </span>
          </Tooltip>
        ) : // </CSVLink>
        null}{" "}
        <React.Fragment>
          {step === 3 ? (
            <Tooltip
              title={t("pages.stuffRequest.text.reproveItemsFromSelectedData")}
            >
              <span>
                <IconButton
                  onClick={reprovarMateriais}
                  disabled={
                    !hasIdSelecionado || loading || user.isSuporte || isOnEdit
                  }
                >
                  <NotInterestedIcon />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
        <React.Fragment>
          {step <= 4 &&
          (((step == 1 || step == 3) && user.isMateriaPrimaCOP) ||
            ((step == 2 || step == 4) && user.isMateriaPrimaBRF) ||
            user.isRoot) ? (
            <Tooltip title="Ir para a próxima etapa">
              <span>
                <IconButton
                  onClick={() =>
                    handleConfimation(
                      t("common.warning"),
                      t("pages.stuffRequest.text.proceedWithRequest")
                    )
                  }
                  disabled={
                    !hasIdSelecionado || loading || user.isSuporte || isOnEdit
                  }
                >
                  <Send />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
        <React.Fragment>
          {step == 4 && (user.isRoot || user.isMateriaPrimaBRF) ? (
            <Tooltip title={t("pages.stuffRequest.text.deleteSelected")}>
              <span>
                <IconButton
                  onClick={() =>
                    handleDeleteConfimation(
                      t("common.warning"),
                      t("pages.stuffRequest.text.proceedWithDelete")
                    )
                  }
                  disabled={
                    !hasIdSelecionado || loading || user.isSuporte || isOnEdit
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
      </div>
      <br />
      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            rowsPerPageOptions={[50, 100, 250, 500]}
            checkboxSelection={
              (user.isRoot ||
                user.isPlanejamento ||
                user.isMateriaPrimaBRF ||
                user.isMateriaPrimaCOP) &&
              step <= 4
            }
            disableSelectionOnClick
            onSelectionModelChange={(ids) => {
              handleSelectionChange(ids);
            }}
            onCellEditStart={() => {
              setIsOnEdit(true);
            }}
            onCellEditStop={() => {
              setIsOnEdit(false);
            }}
            onCellEditCommit={onCellEditCommit}
            onCellClick={(cellValues) => {
              handleClick(cellValues);
            }}
            // onCellKeyDown={}
          />
        </div>
      </div>

      <div className="divFlow" style={{ marginTop: 16 }}>
        <Box sx={{ width: "98%", backgroundColor: "transparent" }}>
          {/* {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 1, mb: 1, fontSize: "small" }}>
                Todas as etapas foram cumpridas. Inclusive a geração do
                Forecast. Ainda é possível alterar dados do contrato, Contudo,
                não será possível recriar o Forecast para os SKU's e o exercício
                já criado! A etapa final será realizada para os SKU's incluidos
                após a última geração de Forecast em : Incluir data aqui
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Resetar</Button>
              </Box>
            </React.Fragment>
          ) : ( */}
          <React.Fragment>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                {t("common.back")}
              </Button>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: React.ReactNode;
                  } = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption">
                        {t("pages.dailyForecast.text.optional")}
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>
                        <Typography variant="caption">{label}</Typography>
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {isStepOptional(activeStep) && (
                <Button
                  color="inherit"
                  onClick={handleSkip}
                  sx={{ mr: 1 }}
                  disabled
                >
                  {t("common.skip")}
                </Button>
              )}
              <Button onClick={handleNext}>
                {activeStep === steps.length - 1
                  ? t("common.finish")
                  : t("common.next")}
              </Button>
            </Box>
          </React.Fragment>
          {/* )} */}
        </Box>
      </div>

      <div>
        <Dialog
          open={openDownload}
          onClose={handleCloseDownload}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.stuffRequest.text.excelImport")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              {FileUploadPage()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleCloseDownload}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={openFilter}
          onClose={handleCloseFilter}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filter"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.stuffRequest.text.filterGridBy")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              <Grid>
                <Grid item>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterlocale={ptBR}
                  >
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={t("common.requestedIn")}
                      value={solicitadaEm}
                      onChange={(newValue: any) => {
                        if (newValue) {
                          newValue.setHours(23);
                          newValue.setMinutes(59);
                          newValue.setSeconds(59);
                          newValue.setMilliseconds(999);
                        }
                        setSolicitadaEm(newValue);
                      }}
                      renderInput={(params: any) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <br />
                <Grid item>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterlocale={ptBR}
                  >
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={t("common.for")}
                      value={para}
                      onChange={(newValue: any) => {
                        if (newValue) {
                          newValue.setHours(23);
                          newValue.setMinutes(59);
                          newValue.setSeconds(59);
                          newValue.setMilliseconds(999);
                        }
                        setPara(newValue);
                      }}
                      renderInput={(params: any) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <br />
                <Grid item>
                  <TextField
                    style={{ width: "100%" }}
                    value={codigoSku}
                    id={"CodigoSku"}
                    name={"CodigoSku"}
                    label={t("common.skuCode")}
                    placeholder={t("common.skuCode")}
                    variant="outlined"
                    onChange={(event) => setCodigoSku(event.target.value)}
                  />
                </Grid>
                <br />
                <Grid item>
                  <TextField
                    style={{ width: "100%" }}
                    value={quantidadeSolicitado}
                    id={"QtdeSolicitada"}
                    name={"QtdeSolicitada"}
                    label={t("common.selectedQuantity")}
                    placeholder={t("common.selectedQuantity")}
                    variant="outlined"
                    onChange={(event) =>
                      setQuantidadeSoliciatado(event.target.value)
                    }
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleFilter}
              autoFocus
            >
              {t("common.filter")}
            </Button>
            <Button
              variant="outlined"
              color="success"
              onClick={handleCloseFilter}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={csvFoiEnviado.isSuccess ? "success" : "error"}
          sx={{ width: "100%" }}
          action={
            <Button
              color="primary"
              size="small"
              onClick={handleClickOpenCSVDetalhesModal}
            >
              {t("common.seeDetails")}
            </Button>
          }
        >
          {csvFoiEnviado.isSuccess
            ? t("common.csvWithSuccess")
            : t("common.csvWithError")}
        </Alert>
      </Snackbar>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={rows.map((item: any) => {
            item.skuSolicitado = montaSkuDescricao(+item.idSkuSolicitado);
            item.skuProposto = montaSkuDescricao(+item.idSkuProposto);
            return item;
          })}
          columns={getDownloadColumns()}
          name={`${t("pages.stuffRequest.pageTitle")} Step ${step}`}
        />
      </Modal>

      <Modal
        open={openCSVDetalhesModal}
        onClose={handleCloseCSVDetalhesModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <CSVDetalhesModal
          handleClose={handleCloseCSVDetalhesModal}
          name={`${t("pages.dailyForecast.titlePage")} Step ${step}`}
          detalhes={csvFoiEnviado.details}
        />
      </Modal>

      {historyId > 0 && (
        <StepLogsHistoryDetalhe
          id={historyId}
          type={"SolicitacaoMatPrima"}
          onClose={() => setHistoryId(0)}
        />
      )}
    </div>
  );
}
